



























import { Component, Vue, Watch } from 'vue-property-decorator';
import Campaigns from '@campaigns/shared/components/Campaigns.vue';
import { loadPendingAdminApprovalCampaignsAction } from '../../shared/actions';
import TableActions from './components/TableActions.vue';
import ClickableCampaignItem from './components/ClickableCampaignItem.vue';
import { AuthorizedUser, Campaign, CampaignTuple } from '@/app/shared/utilities/static-types';
import { getUserById } from '@adminRoles/shared/actions';
import { getCurrentUser } from '@/app/shared/firebase/firebase-user';
import { isCampaignOwner } from '@/app/screens/App/screens/Campaigns/shared/utils';
import namespace from '@/app/shared/store/namespace';

@Component({
  components: {
    Campaigns,
    TableActions,
    ClickableCampaignItem,
  },
})
export default class PendingAdminApprovalCampaigns extends Vue {
  public currentUser: AuthorizedUser|undefined = undefined;
  public campaignsTuples: CampaignTuple[] = [];
  public loading = false;

  public async created() {
    await this.reloadingCampaigns();
  }

  public async loadCurrentUser() {
    const { uid } = (await getCurrentUser())!;
    return getUserById(uid);
  }

  public isCampaignOwner(campaign: Campaign) {
    return isCampaignOwner(campaign)(this.currentUser!);
  }

  public async reloadingCampaigns() {
    try {
      this.campaignsTuples = [];
      this.loading = true;
      this.currentUser = await this.loadCurrentUser();
      this.campaignsTuples = await loadPendingAdminApprovalCampaignsAction();
    } finally {
      this.loading = false;
      // Reset the reloading state
      this.$store.dispatch(`${namespace.CampaignModule}/setCampaignReloadingState`, false);
    }
  }

  // Watcher for Vuex reloadingCampaigns state
  get reloadingCampaignsState() {
    return this.$store.getters[`${namespace.CampaignModule}/getReloadingCampaigns`];
  }

  @Watch('reloadingCampaignsState')
  public async onReloadingCampaignsChanged(newValue: boolean) {
    if (newValue) {
      await this.reloadingCampaigns();
    }
  }
}
